import validateEmail from "@insite/client-framework/Common/Utilities/validateEmail";
import siteMessage from "@insite/client-framework/SiteMessage";
import Button from "@insite/mobius/Button/Button";
import Icon from "@insite/mobius/Icon";
import TextField from "@insite/mobius/TextField";
import Typography from "@insite/mobius/Typography";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import Card from "@midland-industries/Components/Card";
import Stack from "@midland-industries/Components/Stack";
import IconMailSpark from "@midland-industries/Icons/IconMailSpark";
import { colors } from "@midland-industries/Styles/colors";
import React, { useEffect, useState } from "react";
import { css } from "styled-components";

const buttonCss = css`
    span {
        font-size: 15px;
    }
`;

const NewsletterCard: React.FC = () => {
    const history = useHistory();
    const [disabled, setDisabled] = useState(true);
    const [email, setEmail] = useState("");

    useEffect(() => {
        if (email && validateEmail(email)) {
            setDisabled(false);
        } else {
            setDisabled(true);
        }
    }, [email, disabled]);

    return (
        <Card title={siteMessage("Newsletter_Card_Title") as string} width={360} height={321}>
            <Stack align="center" justify="center" style={{ padding: "16px", height: "100%" }}>
                <Icon src={IconMailSpark} width={54} height={54} />
                <Typography lineHeight="24px" color={colors.textAccent} style={{ padding: "8px 0" }}>
                    {siteMessage("Newsletter_Card_Message")}
                </Typography>
                <TextField placeholder="Email" value={email} onChange={e => setEmail(e.currentTarget.value)} />
                <Button
                    disabled={disabled}
                    onClick={() => history.push("/Contact/Subscribe")}
                    style={{ minHeight: 30, marginTop: 6, width: "100%" }}
                    css={buttonCss}
                    mergeCss
                >
                    Sign Up
                </Button>
            </Stack>
        </Card>
    );
};

export default NewsletterCard;
